import { render } from "./DirectorioStreamlined.vue?vue&type=template&id=39056cbc&scoped=true"
import script from "./DirectorioStreamlined.vue?vue&type=script&lang=ts"
export * from "./DirectorioStreamlined.vue?vue&type=script&lang=ts"

import "./DirectorioStreamlined.vue?vue&type=style&index=0&id=39056cbc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39056cbc"

export default script